/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Exemple`}</h1>
    <p>{`Dans la `}<strong parentName="p">{`ville de Genève`}</strong>{`, une personne `}<strong parentName="p">{`célibataire`}</strong>{` avec un `}<strong parentName="p">{`revenu brut de CHF 100'000`}</strong>{` est soumis à une `}<strong parentName="p">{`charge fiscale de 14,8%`}</strong>{` et paie environ `}<strong parentName="p">{`CHF 14'840`}</strong>{` d'impôts cantonaux et communaux.`}</p>
    <p>{`Ce montant peut varier selon les déductions.`}</p>
    <p><strong parentName="p">{`L'impôt sur la fortune`}</strong>{` et `}<strong parentName="p">{`l'impôt fédéral`}</strong>{`, qui est le même dans toutes les communes, n'ont `}<strong parentName="p">{`pas été pris en compte`}</strong>{` dans le calcul.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
  